import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getInstallPromptState, subscribeInstallPrompt, promptInstall } from "../../utils/installPrompt";
import { detectMobileOS, isStandalone, shouldShowInstallOneTap } from "../../utils/installState";

const GOLD = "#D4A017";

// iter69-B B1/B2 — botón "Instalar en 1 toque". SOLO aparece si: no-iOS,
// no-standalone y beforeinstallprompt disparó. Si no dispara → fallback
// silencioso a la guía dorada existente (renderiza null). En iOS jamás.
// Tras appinstalled → CTA inmediato "activa tus avisos" (cierra el embudo).
export default function InstallOneTapButton({ className = "" }) {
  const [state, setState] = useState(getInstallPromptState);
  useEffect(() => subscribeInstallPrompt(setState), []);

  if (state.installed && !isStandalone()) {
    return (
      <Link
        to="/settings?focus=push"
        className={`block w-full text-center py-3 px-4 rounded-full font-bold text-black bg-emerald-400 hover:bg-emerald-300 transition-colors ${className}`}
        data-testid="install-success-cta"
      >
        ✅ Instalada. Ahora activa tus avisos
      </Link>
    );
  }

  if (!shouldShowInstallOneTap(detectMobileOS(), isStandalone(), state.promptAvailable)) return null;

  return (
    <button
      type="button"
      onClick={promptInstall}
      className={`block w-full text-center py-3 px-4 rounded-full font-bold text-black transition-opacity hover:opacity-90 ${className}`}
      style={{ backgroundColor: GOLD }}
      data-testid="install-one-tap-btn"
    >
      📲 Instalar AvisoCar (1 toque)
    </button>
  );
}
